import {
    AnimationBaseController, IAnimationControllerConfiguration,
    Inject,
    GameRandom,
    ModelEvents
} from "@denishussar/html5-game-engine";
import {SwitchController, ISwitchControllerOptions} from "./SwitchController";
import {ElectricityModel} from "../Models/ElectricityModel";
import {ElectricityLogic} from "../Logic/ElectricityLogic";
import {AnimationContents} from "../../../../../../AnimationContents";
import { AchievementType } from "../../../../../Models/Game/AchievementModel";
import { GameLogic } from "../../../../../Logic/GameLogic";
import { MiniGameTypeEnum } from "../../../../../Models/Game/MiniGameModel";

export class GameScreenController extends AnimationBaseController {
    $model: ElectricityModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    private _hasError: boolean = false;

    public constructor(@Inject private _options: any,
                       @Inject private _gameLogic: ElectricityLogic,
                       @Inject private _GameLogic: GameLogic,
                       @Inject private _modelEvents: ModelEvents,
                       @Inject private _random: GameRandom) {
        super("GameScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            animationContent: AnimationContents.ELECTRICITY_JSON,
            libraryName: "mini_game_electricity_container",
            childControllers: {},
            modelEvents: {
                "win": () => {
                    this.$queue.get("win").addToQueue(1);
                }
            },
            queue: {
                "win": {
                    condition: clock => clock > 0.2,
                    action: () => {
                        if (this._options.onComplete) {
                            this._options.onComplete();
                            if (!this._hasError) {
                                this._GameLogic.isAchievements(AchievementType.Responsibility, MiniGameTypeEnum.electricity)
                            }
                        } else {
                            this._hasError = true
                        }
                    }
                },
            },
        };
    }

    protected onInitialize(): void {
        for (let i = 4; i--;) {
            this.addChildController({
                view: SwitchController,
                instanceName: `mini_game_electricity.switch_${i}`,
                options: <ISwitchControllerOptions>{},
                model: this.$model.switches[i]
            }, `switch_${i}`);
        }

        this.setTextByQuery("mini_game_electricity.code", this.$model.code.join(' '));

        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(Math.min(this._screenWidth / this._width / this._screenScale, this._screenHeight / this._height / this._screenScale));
    }
}
